import { render, staticRenderFns } from "./GSelectTurma.vue?vue&type=template&id=367b468a"
import script from "./GSelectTurma.vue?vue&type=script&lang=js"
export * from "./GSelectTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports